import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import Select from "react-select";
import { Column } from "primereact/column";
import { usePermissions } from "../../common/PermissionContext";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const ExternalCompSinclairConstants = () => {

    const [sinclairList, setSinclairList] = useState<any[]>([]);
    const [sinclairId, setSinclairId] = useState("");
    const [genderList, setGenderList] = useState<any[]>([]);
    const [olympicCycle, setOlympicCycle] = useState("");
    const [genderId, setGenderId] = useState("");
    const [comCoffecient_a, setComCoeffecient_a] = useState("");
    const [maxBwtB, setMaxBwtB] = useState("");
    const [status, setStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchSinclairConstants() {
            setIsLoading(true);
            const sinclairConstantsResponse = await func.externalCompSinclairConts(null);
            setSinclairList(Array.isArray(sinclairConstantsResponse) ? sinclairConstantsResponse : [])
            setIsLoading(false);
        }
        fetchSinclairConstants();
    }, []);

    const filteredData = sinclairList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const olympicCycleRender = (rowData) => {
        return <span>{rowData.extComOlympicCycle}</span>;
    };

    const genderRender = (rowData) => {
        return <span>{rowData.extComGender}</span>;
    };

    const coeffecient_aRender = (rowData) => {
        return <span>{rowData.extComCoefficient_a}</span>;
    };

    const maxBwtBRender = (rowData) => {
        return <span>{rowData.extComMax_bwt_b}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    async function newSinclairConst() {
        const genderResponse = await func.externalCompGender(null);
        setGenderList(Array.isArray(genderResponse) ? genderResponse : [])
        setOpenModal(true)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSinclairConstants();
            } else {
                const formData = new FormData();
                formData.append("extComOlympicCycle", olympicCycle);
                formData.append("extComGender", genderId);
                formData.append("extComCoefficient_a", comCoffecient_a);
                formData.append("extComMax_bwt_b", maxBwtB);

                const createsinclair = api.ExternalCompetitionSinclairConstants;
                fetch(createsinclair, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateSinclairConstants() {
        const formData = new FormData();
        formData.append("extComOlympicCycle", olympicCycle);
        formData.append("extComGender", genderId);
        formData.append("extComCoefficient_a", comCoffecient_a);
        formData.append("extComMax_bwt_b", maxBwtB);
        formData.append("status", status);

        const createsinclair = api.ExternalCompetitionSinclairConstants + "/" + sinclairId;
        fetch(createsinclair, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Sinclair Constants</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newSinclairConst() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Sport Sinclair Constant">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComOlympicCycle"
                                                header="Olympic Cycle"
                                                body={olympicCycleRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComGender"
                                                header="Gender"
                                                body={genderRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComCoefficient_a"
                                                header="Coefficient_a"
                                                body={coeffecient_aRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComMax_bwt_b"
                                                header="Max_bwt_b"
                                                body={maxBwtBRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                centered
                show={openModal}
                size="sm">

                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Sinclair Constants</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Olympic Cycle</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={olympicCycle}
                                    onChange={(e) => {
                                        setOlympicCycle(e.target.value);
                                    }}
                                    style={{ height: "40px", padding: "17px" }}
                                    placeholder="Enter Olympic Cycle"
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Gender</label>
                                <Select
                                    value={genderList.find(gender => gender.extComGenderName === genderId) ? {
                                        value: genderId,
                                        label: genderList.find(gender => gender.extComGenderName === genderId).extComGenderName
                                    } : null}
                                    onChange={(e) => {
                                        setGenderId(e.value);
                                    }}
                                    styles={customSelect}
                                    required
                                    options={genderList.map(gender => ({
                                        value: gender.extComGenderName,
                                        label: gender.extComGenderName
                                    }))}>
                                </Select>
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Coeffecient_a</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={comCoffecient_a}
                                    onChange={(e) => {
                                        setComCoeffecient_a(e.target.value);
                                    }}
                                    style={{ height: "40px", padding: "17px" }}
                                    placeholder="Enter Coefficient_a"
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Max_bwt_b</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={maxBwtB}
                                    onChange={(e) => {
                                        setMaxBwtB(e.target.value);
                                    }}
                                    style={{ height: "40px", padding: "17px" }}
                                    placeholder="Enter Max_bwt_b"
                                    required
                                />
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ExternalCompSinclairConstants;